const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/app/terms-agreement.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { toSafeRedirectPath } from '@/utils/safe-redirect';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/app/terms-agreement')({
  validateSearch: search => ({
    redirect: toSafeRedirectPath(search.redirect) ?? '/app'
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}